import React from 'react';
import './stylesHome.css';
import logo from '../assets/logo-mitad.png';
import { Box } from '@mui/system';
import { Container, Typography, Select, MenuItem, FormControl, InputLabel } from '@mui/material';
import { ReactComponent as LogoSVG } from '../assets/logo-animado-x2.svg';
import Image from 'mui-image';
import Footer from './Footer';
import TopNavigation from './TopNavigation';
import CovidPage from './pages/covid/CovidPage';
import OtherPage from './pages/other/OtherPage';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';

import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend,
  ResponsiveContainer, PieChart, Pie, Cell
} from 'recharts';

import dataByYear from '../data/contrataciones.json'; // 👈 JSON local actualizado por año y categoría

const COLORS = [
  '#081d4b', '#1c3a6f', '#305793', '#4474b7',
  '#5891db', '#6caefb', '#80cbff', '#94e8ff', '#a8ffff'
];

const categorias = [
  "TODAS",
  "INFRAESTRUCTURA & OBRAS PUBLICAS",
  "BIENES Y SUMINISTROS",
  "SERVICIOS GENERALES",
  "TECNOLOGIA E INNOVACION",
  "SALUD Y BIENESTAR HUMANO",
  "CULTURA Y DESARROLLO SOCIAL",
  "TRANSPORTE Y LOGISTICA",
  "GESTION AMBIENTAL Y RECURSOS NATURALES",
  "PROYECTOS PRODUCTIVOS Y DESARROLLO ECONOMICO",
  "EDUCACION Y CAPACITACION",
  "SEGURIDAD Y DEFENSA"
];

const Home = () => {
  const [tab, setTab] = React.useState('1');
  const [selectedYear, setSelectedYear] = React.useState('2024');
  const [selectedCategoria, setSelectedCategoria] = React.useState('TODAS');

  const handleChange = (event, newValue) => setTab(newValue);
  const handleYearChange = (event) => setSelectedYear(event.target.value);
  const handleCategoriaChange = (event) => setSelectedCategoria(event.target.value);

  const data = selectedCategoria === 'TODAS'
    ? Object.entries(dataByYear[selectedYear] || {}).flatMap(([cat, valores]) => valores.porMes || [])
        .reduce((acc, item) => {
          const found = acc.find(i => i.name === item.name);
          if (found) {
            found["Cantidad de Contrataciones"] += item["Cantidad de Contrataciones"];
          } else {
            acc.push({ ...item });
          }
          return acc;
        }, [])
    : dataByYear[selectedYear]?.[selectedCategoria]?.porMes || [];

  const data2 = selectedCategoria === 'TODAS'
    ? Object.entries(dataByYear[selectedYear] || {}).flatMap(([cat, valores]) => valores.porCiudad || [])
        .reduce((acc, item) => {
          const found = acc.find(i => i.name === item.name);
          if (found) {
            found.value += item.value;
          } else {
            acc.push({ ...item });
          }
          return acc;
        }, [])
    : dataByYear[selectedYear]?.[selectedCategoria]?.porCiudad || [];

  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
      const totalContrataciones = data2.reduce((sum, entry) => sum + entry.value, 0);
      const porcentaje = ((payload[0].value / totalContrataciones) * 100).toFixed(2);
      return (
        <div style={{
          backgroundColor: '#fff',
          border: '1px solid #ccc',
          padding: '10px',
          borderRadius: '5px'
        }}>
          <p>{`${payload[0].name}: ${payload[0].value} (${porcentaje}%)`}</p>
        </div>
      );
    }
    return null;
  };

  return (
    <>
      <TopNavigation />

      <div className='banner'>
        <Container maxWidth="lg">
          {/* Desplegable para elegir año */}
          <FormControl sx={{ minWidth: 120, marginBottom: 4, marginRight: 2 }}>
            <InputLabel>Año</InputLabel>
            <Select value={selectedYear} label="Año" onChange={handleYearChange}>
              {Object.keys(dataByYear).map((year) => (
                <MenuItem key={year} value={year}>{year}</MenuItem>
              ))}
            </Select>
          </FormControl>

          {/* Desplegable para elegir categoría */}
          <FormControl sx={{ minWidth: 240, marginBottom: 4 }}>
            <InputLabel>Categoría</InputLabel>
            <Select value={selectedCategoria} label="Categoría" onChange={handleCategoriaChange}>
              {categorias.map((cat) => (
                <MenuItem key={cat} value={cat}>{cat}</MenuItem>
              ))}
            </Select>
          </FormControl>

          <Typography variant="h5" align="center" sx={{ fontWeight: "bold", color: "#081d4b" }}>
            Contrataciones {selectedYear} - {selectedCategoria}
          </Typography>

          <div style={{ position: 'relative', width: '100%' }}>
            <ResponsiveContainer width="100%" height={400}>
              <BarChart
                data={data}
                margin={{ top: 20, right: 30, left: 20, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar dataKey="Cantidad de Contrataciones" fill="#081d4b" />
              </BarChart>
            </ResponsiveContainer>

            <br />

            <Typography variant="h5" align="center" sx={{ fontWeight: "bold", color: "#081d4b" }}>
              Contrataciones por Departamento
            </Typography>

            <br />

            <ResponsiveContainer width="100%" height={400}>
              <PieChart>
                <Pie
                  data={data2}
                  cx="50%"
                  cy="50%"
                  innerRadius={90}
                  outerRadius={170}
                  dataKey="value"
                  nameKey="name"
                  labelLine={false}
                  label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                >
                  {data2.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} />
              </PieChart>
            </ResponsiveContainer>
            <br />
          </div>
        </Container>
                 
                     <center>
                      <Typography variant="body1" color="text.secondary">
                        Este trabajo fue realizado por el equpo de Contratos Abiertos Gestion 2025.
                      </Typography>
                     </center>
                    <br />
        <Container maxWidth="lg">
          <div style={{ position: 'relative', width: '100%' }}>
            {/* Capa superpuesta */}
          </div>
          <div>
            <Box sx={{ width: '100%', typography: 'body1' }}>
              <TabContext value={tab}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                  <TabList onChange={handleChange} centered>
                    <Tab label="Covid-19" value="1" />
                    <Tab label="Otros temas" value="2" />
                  </TabList>
                </Box>
                <TabPanel value="1">
                  <CovidPage />
                </TabPanel>
                <TabPanel value="2">
                  <OtherPage />
                </TabPanel>
              </TabContext>
            </Box>
          </div>
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default Home;
